<template>
    <div class="loginBG">
        <div class="contentbox">
            <div class="contItem">
                <div class="leftBox">
                    <!-- <div class="topTime">
                        <div class="times">{{isDownNum}}</div>
                        <div class="timeInfo">下一个倒计时</div>
                    </div> -->
                    
                     
                    <div class="numberC">
                        <!-- <span>{{ currentWordIndex+1 }}</span>/<span>{{ wordList.length }}</span> -->
                    </div>
                    <div class="nextMin" v-if="hideTimeSet">
                        <div class="ready">准备开始</div>
                        <div class="timeMin">{{nextMin}}</div>

                    </div>
                    <div class="showNumber" v-if="!isOver && isShowAll==1 &&isShowTime">{{currentWordIndex+1}}</div>
                    <div class="wordBox" v-if="isOver" ><span style="font-size:40px">默写结束</span></div>
                    <div class="wordBox" v-if="!isOver && isShowAll==3" >
                        <span style="font-size:50px;top:38%;color:#F59B28 ">{{currentWordIndex+1}}/{{SimpleWords.length}}</span>
                        <span style="font-size:40px">请根据听到的音频默写</span>
                    </div>
                    <div class="wordBox" v-if="!isOver && isShowAll==1 &&isShowTime" >
                        <span v-if="!isAnswer && isShowWordItem" :style="{fontSize:newWord.translation.length>12?(value6-16)+'px': value6+'px',top:'30%'}">{{newWord.word}}</span> 
                        <span v-if="!isAnswer && isShowtranItem"   :style="{fontSize:value6+'px'}"><span v-if="isCXshow">{{newWord.pos}}</span> <span>{{newWord.translation}}</span> </span>
                        <span v-if="!isAnswer && isShowyinbiaoItem && newWord.phonetic" :style="{fontSize:value6+'px',top:'70%'}">/{{newWord.phonetic}}/</span>

                         <span v-if="isAnswer && isShowWordItem" :style="{fontSize:value6+'px',top:'30%'}">{{newWord.word}}</span> 
                        <span v-if="isAnswer && isShowtranItem" :style="{fontSize:newWord.translation.length>12?(value6-25)+'px': value6+'px'}"><span v-if="isCXshow">{{newWord.pos}}</span> <span>{{newWord.translation}}</span> </span>
                        <span v-if="isAnswer && isShowyinbiaoItem" :style="{fontSize:value6+'px',top:'70%'}">/{{newWord.phonetic}}/</span>
                    </div>
                    
                    <div class="wordBox" v-if="!isOver && isShowAll==1 &&!isShowTime" ><span v-if="showType == 1" :style="{fontSize:value6+'px'}">*****</span> <span v-if="showType == 2" :style="{fontSize:value6+'px'}">*****</span><span v-if="showType == 3" :style="{fontSize:value6+'px'}">*****</span></div>
                    <div class="buttomItems"  v-if="!isOver">
                          <CheckboxGroup v-model="fruit" @on-change="queryList" >
                            <Checkbox label="词性"></Checkbox>
                        </CheckboxGroup>
                        <div style="margin-left:100px">字体大小：<Input-number :max="200" :min="30" :active-change="false" v-model="value6"></Input-number></div>
                        
                    </div>
                    <div v-if="!isOver && isShowAll==2 &&!payOverType " style="text-align: center;">提示：句子不显示音标</div>
                     <div class="wordBox2" v-if="!isOver && isShowAll==2 " >
                        <div class="WordPage" v-for="(item,index) in resultList[pageNum]" :key="index" :style="{display:isAnswer?'block':'flex'}">
                            <div class="indexPg">{{item.index+1}}</div>
                            <div class="wordNe" v-if="isShowTime && !isAnswer && isShowtranItem" :style="{color:pageIndex == index?'red':'',fontSize:value7+'px'}"><span v-if="isCXshow">{{item.pos}}</span> {{item.translation}}</div>
                            <div class="zhSize" v-if="isShowTime && !isAnswer && isShowWordItem" :style="{color:pageIndex == index?'red':'',fontSize:value7+'px'}">{{item.word}}</div>
                            <div class="zhSize" v-if="isShowTime && !isAnswer && isShowyinbiaoItem && item.phonetic" :style="{color:pageIndex == index?'red':'',fontSize:value7+'px'}">/{{item.phonetic}}/</div>

                            <div class="zhSize" v-if="isAnswer && isShowWordItem" :style="{color:pageIndex == index?'red':'',fontSize:item.word.length>14?(value7-8)+'px': value7+'px',width:'100%',height:'33.3%'}">{{item.word}}</div>
                             <div class="wordNe" v-if="isAnswer && isShowtranItem" :style="{color:pageIndex == index?'red':'',fontSize:item.translation.length>10?(value7-8)+'px': value7+'px',width:'100%',height:'33.3%'}"><span v-if="isCXshow">{{item.pos}}</span> {{item.translation}}</div>
                             <div class="zhSize" v-if="isAnswer && isShowyinbiaoItem && item.phonetic" :style="{color:pageIndex == index?'red':'',fontSize:value7+'px',width:'100%',height:'33.3%'}">/{{item.phonetic}}/</div>

                            <div class="zhSize" v-if="!isShowTime && !isAnswer" :style="{color:pageIndex == index?'red':'',fontSize:value7+'px'}">*****</div>
                        </div>

                     </div>
                     <div class="buttomItems"  v-if="!isOver">
                         <CheckboxGroup v-model="fruit" @on-change="queryList">
                            <Checkbox label="词性"></Checkbox>
                        </CheckboxGroup>
                        <div style="margin-left:40px;display: flex;" v-if="isShowAll==2"> <span> 字体大小：</span><Slider style="width: 100px;" v-model="value7" :max="50" :min="20" ></Slider>
                            <!-- <Input-number class="sizeInput" :max="50" @on-change="setFontSize" :min="10" :active-change="false" v-model="value7" ></Input-number> -->
                        </div>
                        <div class="sizeBnt" v-if="isSort" @click="sortBtns(0)">乱序练习</div>
                        <div class="sizeBnt" v-if="!isSort" @click="sortBtns(1)">顺序练习</div>
                    </div>
                </div>
            <div class="rightBox">
                <div class="timesNumber"><Icon type="ios-clock" size="30" color="#207DE5" />用时</div>
                <div class="numberItem">
                    <div class="timeItem">{{minutes1}}</div>
                    <div class="timeItem">{{minutes2}}</div>
                    <div class="timeItem1">:</div>
                    <div class="timeItem">{{seconds1}}</div>
                    <div class="timeItem">{{seconds2}}</div>
                </div>
               
                <div class="rightBtnFX" style="margin-top:180px">
                    <div class="startBtn" @click="proSubject" v-if="isShowAll==1"><Icon type="md-arrow-dropup" style="margin-top:-4px" size="30" />上一个</div>
                    <div class="startBtn" @click="nextSubJect" v-if="isShowAll==1"><Icon type="md-arrow-dropdown" size="30" />下一个</div>

                    <div class="startBtn" @click="proSubject1" v-if="isShowAll==2"><Icon type="md-arrow-dropup" style="margin-top:-4px" size="30" />上一页</div>
                    <div class="startBtn" @click="nextSubJect1" v-if="isShowAll==2"><Icon type="md-arrow-dropdown" size="30" />下一页</div>
                </div>
                 
                <div class="rightBtnFX">
                    <Button type="primary" class="goback" @click="goback"><Icon v-if="!isPay" type="md-arrow-dropright-circle" /><Icon v-if="isPay" type="md-pause" /> <span v-if="isPay">暂停报默</span><span v-if="!isPay">开始报默</span> </Button>
                    <Button type="primary" class="goback" v-if="isOver" @click="showAnster">显示答案</Button>
                    <Button type="primary" class="goback" @click="goHome"><Icon type="md-exit" />返回列表</Button>
                </div>
                
                <div class="boxLeftBtn" @click="showDrawer()">
                    <img src="https://r.bjwxjs.com/EnImage/pcLineboxYingyu.png" alt="">设置
                </div>
            </div>
            </div>
            </div>
            <audio ref="audio"  controls="controls" class="audiosBox" @ended="overAudio"></audio>
             <div class="payVipBox" v-if="!is_payed">
                <div class="PayBoxs">
                    <div class="payTitle">提示</div>
                    <div class="infosBox">开通会员后即可使用小程序全部功能(包含投屏默写)</div>
                    <div class="payMage">
                        <img src="../assets/pay.png"></img>
                    </div>
                    <div class="buttonTitle">扫码立即开通永久会员</div>
                </div>
                <Button type="primary" class="goback poson" @click="goHome"><Icon type="md-exit" />返回列表</Button>
            </div>
            <!-- v-if="drawer" -->
            <div class="drawerBox" v-if="drawer">
                <!-- <Dropdown @on-click="checkType">
                    <Button type="primary" class="goback"><Icon type="ios-arrow-down"></Icon><span v-if="showType ==1">播放英文</span><span v-if="showType == 2">播放中文</span><span v-if="showType == 3">看音标默写</span></Button>
                    <DropdownMenu slot="list">
                        <DropdownItem :name='1'>播放英文</DropdownItem>
                        <DropdownItem :name='2'>播放中文</DropdownItem>
                        <DropdownItem :name='3'>看音标默写</DropdownItem>
                    </DropdownMenu>
                </Dropdown> -->
                <div class="drawerBoxTitle">
                    <img src="https://r.bjwxjs.com/EnImage/pcLineboxSelectYingyu.png" alt="">设置
                    <!-- <div class="closeBtn" ></div> -->
                </div>
                 <div class="drawerTitle">显示</div>
                 <div class="optBoxAudio">
                    <div class="zhBox" :style="{color:isShowAll == 1?'rgb(32, 125, 229)':''}" @click="CheckisShowAll(1)">单显</div>
                    <div class="zhBox" :style="{color:isShowAll == 2?'rgb(32, 125, 229)':''}"  @click="CheckisShowAll(2)">全显</div>
                    <div class="zhBox" :style="{color:isShowAll == 3?'rgb(32, 125, 229)':''}"  @click="CheckisShowAll(3)">不显</div>
                 </div>
                 <div class="optBoxAudio" v-if="isShowAll!=3">
                    <div class="zhBox" :style="{color:isShowWordItem?'rgb(32, 125, 229)':''}" @click="CheckWordText(1)">英文</div>
                    <div class="zhBox" :style="{color:isShowtranItem?'rgb(32, 125, 229)':''}" @click="CheckWordText(2)">中文</div>
                    <div class="zhBox" :style="{color:isShowyinbiaoItem?'rgb(32, 125, 229)':''}" @click="CheckWordText(3)">音标</div>
                 </div>
                 <!-- <Radio-group v-model="showType" @on-change="CheckisShowAll">
                    <Radio label="1">中文</Radio>
                    <Radio label="2">英文</Radio>
                    <Radio label="3">音标</Radio>
                </Radio-group>

                 <Radio-group v-model="showType" @on-change="CheckisShowAll">
                    <Radio label="1">单显</Radio>
                    <Radio label="2">全显</Radio>
                    <Radio label="3">不显</Radio>
                </Radio-group> -->
                <!-- <Radio-group v-model="showType" @on-change="checkType">
                    <Radio label="1">播放英文</Radio>
                    <Radio label="2">播放中文</Radio>
                </Radio-group> -->
                <div class="drawerTitle">播放</div>
                <div class="optBoxAudio">
                    <div class="zhBox clwidth" :style="{color:showType == 1?'rgb(32, 125, 229)':''}" @click="checkType(1)">播放英文</div>
                    <div class="zhBox clwidth" :style="{color:showType == 2?'rgb(32, 125, 229)':''}" @click="checkType(2)">播放中文</div>
                 </div>
                 <div class="optBoxAudio">
                    <div class="zhBox clwidth" :style="{color:showType == 3?'rgb(32, 125, 229)':''}" @click="checkType(3)">先英后中 </div>
                    <div class="zhBox clwidth" :style="{color:showType == 4?'rgb(32, 125, 229)':''}" @click="checkType(4)">先中后英</div>
                 </div>
                <!-- <Dropdown @on-click="CheckisShowAll">
                    <Button type="primary" class="goback"><Icon type="ios-arrow-down"></Icon><span v-if="isShowAll==1">显示单个</span><span v-if="isShowAll==2">显示全部</span><span v-if="isShowAll==3">只听音频</span></Button>
                    <DropdownMenu slot="list">
                        <DropdownItem :name='1'>显示单个</DropdownItem>
                        <DropdownItem :name='2'>显示全部</DropdownItem>
                        <DropdownItem :name='3'>只听音频</DropdownItem>
                    </DropdownMenu>
                </Dropdown> -->
                <div class="flexBoxLarge">
                    <div class="bottomBox">
                        <span>读</span>
                        <Input-number v-model="value1" @on-change="setMiaoTime" :min="1" :max="10" size="large"></Input-number>
                        <span>遍</span>
                    </div>
                    <div class="bottomBox">
                        <span>隔</span>
                        <Input-number v-model="value2" @on-change="setMin" :min="1" :max="20" size="large"></Input-number>
                        <span>秒</span>
                    </div>
                </div>
                <div class="colesSet" @click="closeBtn()">关闭设置</div>
            </div>
        </div>
</template>
  
  <script>
import axios from "axios";
import qs from "qs"
import jsPDF from 'jspdf';
import ASEUrl from "../cryptojs/secret"
export default {
    data() {
      return {
        value1:2,//多少遍
        value2:5,//间隔
        value3:80,//字体大小
        currentWordIndex: 0, // 当前第n个单词
        wordInfo: {},//请求数据
        wordList: [], // 词语列表
        newWord:{
            word:'',
            translation:'',
            phonetic:'',
            pos:''
        },//当前词语
        SimpleWords:[],//单词列表
        minutes: 0,  
        seconds: 0,
        minutes1: 0,  
        seconds1: 0,
        minutes2: 0,  
        seconds2: 0,
        timer:'',//计时器
        ticket:'',//下载凭证
        wordUrl:'',//下载url
        isNum:'',//第几次
        jsTime:'',//倒计时定时器
        isPay:false,//是否播放
        isDownNum:'',//倒计时
        showType:'1',//显示类型
        isMiao:'',
        isOver:false,
        daoTime:'',
        isShowAll:3,
        pageNum:0,
        pageIndex:0,
        resultList:[],
        is_payed:true,
        value6:75,
        value7:30,
        isSort:true,
        oldList:'',
        newList:'',
        isShowTime:false,
        fruit: ['词性'],
        isCXshow:true,
        nextMin:3,
        readyTIme:'',
        hideTimeSet:false,
        isFirst:true,
        playEnType:0,  // 0 单独单词 1 单独句子 2 单词和句子
        allwordList:[],//单词集合
        allSenTList:[],// 句子集合
        resultWordList:[],//多个显示单词分页
        resultSentList:[],//多个显示句子分页
        payOverType:true,
        miniValue:5,
        isOrder:'1',
        isAnswer:'',
        drawer:false,
        isShowWordItem:true,
        isShowtranItem:true,
        isShowyinbiaoItem:true,
        
      };
    },
     watch: {
    //  "value1" (newVal, oldVal){
    //     let that = this
    //     that.$refs.audio.pause()
    //      that.isNum = 1
    //      that.newWord = that.SimpleWords[that.currentWordIndex]
    //     if(that.showType == 2){
    //         that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
            
    //     }else{
    //         that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
            
    //     }
    //     that.$refs.audio.play()
    //  }
 },
    created() {
        if(window.localStorage.getItem('pc_severalTimes')){
            this.value1 =Number(window.localStorage.getItem('pc_severalTimes')) 
        }
         if(window.localStorage.getItem('pc_interval')){
            this.value2 = Number(window.localStorage.getItem('pc_interval'))
            this.miniValue = Number(window.localStorage.getItem('pc_interval'))
        }
        if(window.localStorage.getItem('pc_fontSize')){
            this.value7 = Number(window.localStorage.getItem('pc_fontSize'))
        }   
        if(window.localStorage.getItem('pc_isShowWordItem')){
            this.isShowWordItem = window.localStorage.getItem('pc_isShowWordItem') == '1'?true:false
        }
        if(window.localStorage.getItem('pc_isShowtranItem')){
            this.isShowtranItem = window.localStorage.getItem('pc_isShowtranItem') == '1'?true:false
        }
        if(window.localStorage.getItem('pc_isShowyinbiaoItem')){
            this.isShowyinbiaoItem = window.localStorage.getItem('pc_isShowyinbiaoItem') == '1'?true:false  
        }
        if(window.localStorage.getItem('pc_isShowAll')){
            this.isShowAll = window.localStorage.getItem('pc_isShowAll')
        }
        if(window.localStorage.getItem('pc_showType')){
            this.showType = window.localStorage.getItem('pc_showType')
        }
    },
    mounted() {
        this.id = this.$route.query.id
        this.isOrder = this.$route.query.isOrder
        if(this.$route.query.isAnswer){
            this.isAnswer = 1
            this.isShowAll = 1
            this.isShowTime = true
        }
        if(this.$route.query.type == 3){
            this.sType = this.$route.query.type
            this.queryScreenWordList()
        }else{
            this.queryWordList()
        }
        this.isDownNum= this.value2 
         this.isQueryVip()
    },
    methods: {
        CheckWordText(e){
            // this.showType = e
            if(e == 1){
                this.isShowWordItem=!this.isShowWordItem
                window.localStorage.setItem('pc_isShowWordItem',this.isShowWordItem?'1':'0')
            }
            if(e == 2){
                this.isShowtranItem=!this.isShowtranItem
                window.localStorage.setItem('pc_isShowtranItem',this.isShowtranItem?'1':'0')
            }
             if(e == 3){
                this.isShowyinbiaoItem=!this.isShowyinbiaoItem
                window.localStorage.setItem('pc_isShowyinbiaoItem',this.isShowyinbiaoItem?'1':'0')
            }
        },
        showDrawer(){
            this.drawer = true
        },
        closeBtn(){
            this.drawer = false
        },
        queryList(e){
            let list = e
            list.indexOf('词性')>-1? this.isCXshow = true :this.isCXshow = false
      },
        sortBtns(type){
            let that = this
            this.isSort = !this.isSort
            this.isPay = false
            this.$refs.audio.pause()
            that.currentWordIndex =0
            this.isNum = 1
             this.pageIndex = 0
               clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
            if(type==0){
                if(that.isShowAll == 2){
                       if(this.isOrder == 1){
                    that.newWord = this.SimpleWords[that.currentWordIndex]
                    const arr = this.SimpleWords.sort(this.randomSort);
                    arr.map((item,index)=>{
                        item.index = index
                    })
                    const chunkSize = 18;
                    const result = [];
                    for (let i = 0; i < arr.length; i += chunkSize) {
                        result.push(arr.slice(i, i + chunkSize));
                    }
                    that.resultList = result
                }else{
                    let arr1 = []
                    let arr2 = []
                    if(this.allwordList.length){
                        arr1 = this.allwordList.sort(this.randomSort);
                    }
                    if(this.resultSentList.length){
                    arr2 = this.allSenTList.sort(this.randomSort);
                    }
                    
                    arr1.map((item,index)=>{
                        item.index = index
                    })
                    arr2.map((item,index)=>{
                        item.index = index
                    })
                    that.allwordList=arr1
                    that.allSenTList=arr2
                    const chunkSize = 18;
                    const result = [];
                    for (let i = 0; i < arr1.length; i += chunkSize) {
                        result.push(arr1.slice(i, i + chunkSize));
                    }
                    that.resultWordList = result

                    const result1 = [];
                    for (let i = 0; i < arr2.length; i += chunkSize) {
                        result1.push(arr2.slice(i, i + chunkSize));
                    }
                    that.resultSentList = result1
                    if(that.playEnType == 0 || that.playEnType == 2){
                        that.resultList = that.resultWordList

                    }
                    if(that.playEnType == 1){
                        that.resultList = that.resultSentList
                    }
                        that.newWord = that.resultList[that.currentWordIndex]
                        if(that.showType == 2 || that.showType == 4){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord[0].translation)
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord[0].word)
                            
                        }

                    }
                }else{
                    const arr = this.SimpleWords.sort(this.randomSort);
                     this.SimpleWords = arr
                     that.newWord = arr[that.currentWordIndex]
                       if(that.showType == 2 || that.showType == 4){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                }
            }else{
                 if(this.sType == 3){
                    this.queryScreenWordList()
                }else{
                    this.queryWordList()
                }
            }

        },
        setMin(e){
            this.miniValue = e
            this.value2 = e
            window.localStorage.setItem('pc_interval', e)
        },
        setMiaoTime(e){
            this.value1 = e
            window.localStorage.setItem('pc_severalTimes',this.value1)
        },
        showAnster(){
            this.isShowAll = 2
            this.isOver = false
        },
        isQueryVip(){
        var that = this
        axios({
            headers:{
               'Content-Type':'application/x-www-form-urlencoded',
                'Authorization': window.localStorage.getItem('sessionId'),
            },
            method: 'GET',
            url: 'v1/user/perm',
            })
            .then((res) => {
                if (typeof res.data === 'string') {
                    res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
                } 
                     that.is_payed = res.data.data.is_payed
                })
            .catch((err) => {
                that.$Message.error(err);
            });
        },
        randomSort(a, b) { return Math.random() > 0.5 ? -1 : 1; },
        checkType(e){
            this.showType = e
            window.localStorage.setItem('pc_showType',e)
            this.isPay = false
              clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
             this.$refs.audio.pause()
             if(this.sType == 3){
                    this.queryScreenWordList()
                }else{
                    this.queryWordList()
                }
        },
        CheckisShowAll(e){
            this.isShowAll = e 
            window.localStorage.setItem('pc_isShowAll',e)
        },
        goHome(){
            this.$router.push({name:'topicList',query:{qtype:this.$route.query.qtype}})
        },
        startTimer () {
            this.seconds += 1; //秒自增 >=60变成 0秒 分加 1分钟
            if (this.seconds >= 60) {
                this.seconds = 0;
                this.minutes = this.minutes + 1;
            }
            let s = this.seconds
            let m = this.minutes
            if(s>9){
              this.seconds1 = s.toString().substring(0,1)
              this.seconds2 = s.toString().substring(2,1)

            }else{
              this.seconds1 =  '0'
              this.seconds2 = s.toString().substring(0,1)
            }

            if(m>9){
              this.minutes1 = m.toString().substring(0,1)
              this.minutes2 = m.toString().substring(2,1)
            }else{
                this.minutes1 =  '0'
                this.minutes2 = m.toString().substring(0,1)
            }
        },
        setreadyTime(){
            let that = this
            that.readyTIme = setInterval(function(){
                    that.nextMin = that.nextMin-1
                    if(that.nextMin == 0){
                        clearInterval(that.readyTIme)
                        that.hideTimeSet= false
                        that.isFirst= false
                        that.isShowTime = true
                         if(that.showType == 2 || that.showType == 4){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }

                        that.$refs.audio.play()
                        
                    }
                },1000)
        },
        goback(){
            let that = this
            this.isPay = !this.isPay
            window.localStorage.setItem('pc_severalTimes',this.value1)
            window.localStorage.setItem('pc_interval',this.value2)
           
            if(this.isPay){
                this.$refs.audio.pause()
                clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
                 this.timer = setInterval(this.startTimer, 1000);
                this.isOver = false
                that.nextMin = 3
                if(that.isOrder == 2){
                      if(this.currentWordIndex == 0 && that.payOverType){
                        if( that.playEnType == 2){
                            this.payOverType = true
                        this.resultList = that.resultWordList
                        }else if(this.playEnType == 0){
                            this.payOverType = true
                            this.resultList = that.resultWordList
                        }else if(this.playEnType == 1){
                            this.resultList = that.resultSentList
                            this.payOverType = false
                        }
                        this.newWord = this.SimpleWords[this.currentWordIndex]
                        this.seconds = 0
                        this.seconds1 = 0
                        this.seconds2 = 0
                        this.minutes1 = 0
                        this.minutes2 = 0
                    }
                }else{
                     this.newWord = this.SimpleWords[this.currentWordIndex]
                }
              
                    if(that.isFirst){
                        if(that.isOrder == 1){
                            that.setreadyTime()
                             that.hideTimeSet = true
                        }else{
                            if(that.playEnType == 2){
                                that.$refs.audio.src = encodeURI('https://r.bjwxjs.com/EnAudio/part_word1.mp3')
                            }else if(that.playEnType == 1){
                                that.$refs.audio.src = encodeURI('https://r.bjwxjs.com/EnAudio/prompt_sentence.mp3')
                                that.value2 = 2
                            }else if(that.playEnType == 0){
                                that.$refs.audio.src = encodeURI('https://r.bjwxjs.com/EnAudio/word1.mp3')
                            }
                                that.$refs.audio.play()

                            setTimeout(() => {
                                that.setreadyTime()
                            }, 4000);
                        }
                    }else{
                        that.hideTimeSet= false
                        if(that.playEnType == 1  || !that.payOverType){
                            this.miniValue = this.newWord.word.split(' ')*that.value2
                        }
                        that.$refs.audio.play()
                    }

            }else{
                    this.newWord = this.SimpleWords[this.currentWordIndex]
                    clearTimeout(that.jsTime)
                    clearInterval(that.timer)
                    clearInterval(that.setint)
                    clearTimeout(that.daoTime)
                    clearTimeout(that.isMiao)
                    that.isDownNum = that.value2
                    that.$refs.audio.pause()
                // this.currentWordIndex = 0
            }
        },

      proSubject() {
        if(this.currentWordIndex == 0){
             clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
                this.isPay = false
            if(!this.playEnType && this.allwordList.length){
                this.playEnType = true
                this.currentWordIndex = this.allwordList.length-1
                this.SimpleWords = this.allwordList
                this.newWord = this.SimpleWords[this.currentWordIndex]
            }
            if(this.currentWordIndex == 0 && this.playEnType){
                this.$Message.warning('当前已经是第一题');
            }
            if(this.currentWordIndex == 0 && !this.playEnType && this.allwordList.length == 0){
                this.$Message.warning('当前已经是第一题');
            }
        }else{
            this.$refs.audio.pause()
            this.currentWordIndex = this.currentWordIndex -1
            this.newWord = this.SimpleWords[this.currentWordIndex]
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            this.isPay = false
        }
      },
      nextSubJect(){
        let that = this
        if(this.currentWordIndex == this.wordList.length-1){
            if(this.playEnType && this.allSenTList.length){
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
                this.isPay = false
                this.currentWordIndex = 0
                this.SimpleWords= this.allSenTList
                that.playEnType = false
                this.newWord = this.SimpleWords[this.currentWordIndex]
                this.value2 = 2
            }
            if(!this.playEnType && this.allSenTList.length == this.currentWordIndex){
                this.$Message.warning('当前已经是最后一题');
            }
            
        }else{
            this.$refs.audio.pause()
            this.currentWordIndex = this.currentWordIndex +1
            this.newWord = this.SimpleWords[this.currentWordIndex]
            that.value3 = that.newWord.translation.length < 10? 80:that.newWord.translation.length  < 15? 50:36
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            this.isPay = false
        }
      },
      proSubject1(){
        if(this.pageNum == 0 ){
            if(this.payOverType){
                this.$Message.warning('当前已经是第一页');
            }
             if(!this.payOverType){
                  clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
                this.isPay = false
                this.payOverType = true
                this.pageNum = this.resultWordList.length-1
                this.resultList = this.resultWordList
                this.SimpleWords = this.allwordList
                this.currentWordIndex = 0
                this.newWord = this.SimpleWords[this.currentWordIndex]
            }
        }else{
            this.pageNum = this.pageNum-1
            this.pageIndex = 0
            this.$refs.audio.pause()
            this.currentWordIndex = this.pageNum == 0? 0:this.pageNum*18
            this.newWord = this.SimpleWords[this.currentWordIndex]
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            this.isPay = false
        }
      },
      nextSubJect1(){
        if(this.resultList.length == this.pageNum+1){
            if(this.payOverType && this.resultSentList.length == 0){
                this.$Message.warning('当前已经是最后一页');
            }
             if(!this.payOverType){
                this.$Message.warning('当前已经是最后一页');
            }
              if(this.payOverType && this.resultSentList.length == this.pageNum+1){
                  this.$Message.warning('当前已经是最后一页');
                  return false
              }
            if(this.payOverType && this.resultSentList.length && this.pageNum+1!=this.resultSentList.length){
                  clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
                this.isPay = false
                this.pageNum = 0
                this.value2 = 2
                this.payOverType = false
                this.resultList = this.resultSentList
                this.SimpleWords = this.allSenTList
                 this.currentWordIndex = 0
                this.newWord = this.SimpleWords[this.currentWordIndex]
            }
            
        }else{
            this.$refs.audio.pause()
            this.pageNum= this.pageNum+1
            this.pageIndex = 0
            this.currentWordIndex = this.pageNum*18
            this.newWord = this.SimpleWords[this.currentWordIndex]
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            this.isPay = false
        }
      },
        overAudio(){
            const that = this
            if(this.isFirst){
                return false
            }
            if(this.showType == 1|| this.showType == 2){
                if(that.isNum == that.value1 ){
                    that.isNum = 1
                    let num2 = that.value2
                    
                    if(that.currentWordIndex+1 == that.SimpleWords.length){
                        that.isDownNum = that.value2
                        

                        if(that.playEnType == 2 && that.payOverType){
                            setTimeout(() => {
                            that.$refs.audio.src = encodeURI('https://r.bjwxjs.com/EnAudio/prompt_part_sentence.mp3')
                            that.payOverType = false
                            that.SimpleWords = that.allSenTList
                                that.newWord = that.SimpleWords[that.currentWordIndex]
                                that.resultList = that.resultSentList
                                that.pageIndex = 0
                                that.pageNum = 0
                                that.isNum = 0
                                that.value2 = 2
                                that.$refs.audio.play()
                            
                        },4000);
                        }else{
                            clearTimeout(this.jsTime)
                            clearInterval(this.setint)
                            clearTimeout(this.isMiao)
                            clearInterval(this.timer)
                            that.currentWordIndex = 0
                                that.isOver = true
                            that.daoTime = setTimeout(() => {
                            
                                that.payOverType = true

                            }, that.miniValue*1000);
                                this.isPay = false
                                this.isFirst = true
                            }
                            if(this.sType == 3){
                                this.queryScreenWordList()
                            }else{
                                this.queryWordList()
                            }

                    }else{
                        that.setint = setInterval(function(){
                        num2 = num2 -1
                        if(num2 == 0){
                            clearInterval(that.setint)
                            that.isDownNum = that.value2
                        }else{
                            that.isDownNum = num2
                        }
                    },1000)
                    if(that.playEnType == 1  || !that.payOverType){
                            this.miniValue = this.newWord.word.split(' ').length*that.value2
                        }
                        that.jsTime = setTimeout(function(){
                        that.currentWordIndex = that.currentWordIndex+1
                        
                        if(that.pageIndex == 17){
                            that.pageNum = that.pageNum+1
                            that.pageIndex = 0
                        }else{
                            that.pageIndex = that.pageIndex+1
                        }
                        if(this.playEnType == 0 || this.playEnType == 2){
                            that.SimpleWords = this.allwordList
                        }
                        that.newWord = that.SimpleWords[that.currentWordIndex]
                    if(that.showType == 2 || that.showType == 4){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                        that.$refs.audio.play()
                    },that.miniValue*1000)
                    }
                    
                }else{
                    const that =this
                    this.isMiao = setTimeout(() => {
                        if(that.showType == 2){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                            
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                        that.$refs.audio.play()
                        that.isNum = this.isNum+1
                    }, that.payOverType?2000:4000);
                }
            }else{
                if(that.isNum>that.value1*2-1 ){
                    let num2 = that.value2
                    that.isNum = 1
                    if(that.currentWordIndex+1 == that.SimpleWords.length){
                        that.isDownNum = that.value2
                        if(that.playEnType == 2 && that.payOverType){
                            setTimeout(() => {
                            that.$refs.audio.src = encodeURI('https://r.bjwxjs.com/EnAudio/prompt_part_sentence.mp3')
                            that.payOverType = false
                            that.SimpleWords = that.allSenTList
                                that.newWord = that.SimpleWords[that.currentWordIndex]
                                that.resultList = that.resultSentList
                                that.pageIndex = 0
                                that.pageNum = 0
                                that.isNum = 0
                                that.value2 = 2
                                that.$refs.audio.play()
                            
                        },4000);
                        }else{
                            clearTimeout(this.jsTime)
                            clearInterval(this.setint)
                            clearTimeout(this.isMiao)
                            clearInterval(this.timer)
                            that.currentWordIndex = 0
                                that.isOver = true
                            that.daoTime = setTimeout(() => {
                            
                                that.payOverType = true

                            }, that.miniValue*1000);
                                this.isPay = false
                                this.isFirst = true
                            }
                            if(this.sType == 3){
                                this.queryScreenWordList()
                            }else{
                                this.queryWordList()
                            }

                    }else{
                        that.setint = setInterval(function(){
                        num2 = num2 -1
                        if(num2 == 0){
                            clearInterval(that.setint)
                            that.isDownNum = that.value2
                        }else{
                            that.isDownNum = num2
                        }
                    },1000)
                    if(that.playEnType == 1  || !that.payOverType){
                            this.miniValue = this.newWord.word.split(' ').length*that.value2
                        }
                        that.jsTime = setTimeout(function(){
                        that.currentWordIndex = that.currentWordIndex+1
                        
                        if(that.pageIndex == 17){
                            that.pageNum = that.pageNum+1
                            that.pageIndex = 0
                        }else{
                            that.pageIndex = that.pageIndex+1
                        }
                        if(this.playEnType == 0 || this.playEnType == 2){
                            that.SimpleWords = this.allwordList
                        }
                        that.newWord = that.SimpleWords[that.currentWordIndex]
                    if(that.showType == 2 || that.showType == 4){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                        that.$refs.audio.play()
                    },that.miniValue*1000)
                    }
                    
                }else{
                    const that =this
                    console.log(that.isNum%2,'次数')
            
                    this.isMiao = setTimeout(() => {
                        if(that.showType == 4 && that.isNum%2 == 1){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }else if(that.showType == 4 && that.isNum%2 == 0){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else if(that.showType == 3 && that.isNum%2 == 1){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else if(that.showType == 3 && that.isNum%2 == 0){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }
                        that.$refs.audio.play()
                        that.isNum = this.isNum+1
                    }, that.payOverType?2000:4000);
                }

            }
                
            
        },
        setFontSize(e){
            this.value7 = e
            window.localStorage.setItem('pc_fontSize',e)
        },
      
      queryVideoUrl(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: 'v1/export/ticket/'+that.id,
          data:{
            }
          })
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.wordUrl = res.data.data.url+'?ticket='+res.data.data.ticket
                if(that.showType == 2|| that.showType == 4){
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                }else{
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                }
                that.isNum = 1
            }else{
                if(res.data.msg == '无效的sessionid'){
                    that.$router.push({name:'login',query:{qtype:this.$route.query.qtype}});
                }else{
                    that.$Message.error(res.data.msg);
                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
      settimeFunc(){
      },
      queryWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Authorization': window.localStorage.getItem('sessionId')
          },
          method: 'GET',
          url: 'v1/dict/'+this.id,
          data:{}
          })
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.spinShow = false
                that.wordInfo = res.data.data
               let SimpleWords = []
                
                that.currentWordIndex = 0
                that.pageNum = 0
                that.pageIndex = 0
                
                // let arr = res.data.data.dict_info.content
                // if(this.showType == 3){
                //     that.pageIndex = 0
                //     let list = res.data.data.dict_info.content || []
                //     let list1 = []
                //     list.map((item)=>{
                //         if(item.phonetic){
                //             list1.push(item)
                //         }
                //     })
                   
                //     SimpleWords = list1
                //     that.SimpleWords = list1
                //     // arr = list1

                // }else{
                    SimpleWords = res.data.data.dict_info.content || []
                    that.SimpleWords = res.data.data.dict_info.content
                   
                // }

                that.queryVideoUrl()

                if(that.isOrder == 1){
                    const arr = res.data.data.dict_info.content
                        arr.map((item,index)=>{
                            item.index = index
                        })
                    that.newWord = SimpleWords[that.currentWordIndex]

                    const chunkSize = 18;
                    const result = [];
                    for (let i = 0; i < arr.length; i += chunkSize) {
                        result.push(arr.slice(i, i + chunkSize));
                    }
                    that.resultList = result
                    that.oldList = JSON.parse(JSON.stringify(res.data.data.dict_info.content)) 

                }else{
                    let allwordList = []
                    let allSenTList = []
                    SimpleWords.map(item=>{
                        if(item.word.indexOf(' ')>-1){
                            allSenTList.push(item)
                        }else{
                            allwordList.push(item)
                        }
                    })

                    allwordList.map((item,index)=>{
                        item.index = index
                    })

                    allSenTList.map((item,index)=>{
                        item.index = index
                    })

                    this.allwordList = allwordList
                    this.allSenTList = allSenTList

                    if(this.allwordList.length > 0&& this.allSenTList.length>0){
                        that.playEnType = 2
                        that.wordList = allwordList
                        that.SimpleWords = allwordList
                    }else if(this.allwordList.length>0 && this.allSenTList.length == 0){
                        this.playEnType = 0
                        that.wordList = allwordList
                        that.SimpleWords = allwordList
                    }else if(this.allSenTList.length>0 && this.allwordList.length == 0){
                        this.playEnType = 1
                        that.wordList = allSenTList
                        that.SimpleWords = allSenTList
                    }

                    that.newWord = this.wordList[that.currentWordIndex]

                    const chunkSize = 18;
                    const result = [];
                    for (let i = 0; i < allwordList.length; i += chunkSize) {
                        result.push(allwordList.slice(i, i + chunkSize));
                    }
                    that.resultWordList = result

                    const result1 = [];
                    for (let i = 0; i < allSenTList.length; i += chunkSize) {
                        result1.push(allSenTList.slice(i, i + chunkSize));
                    }
                    that.resultSentList = result1
                    // resultList
                    if( that.playEnType == 2){
                    this.resultList = that.resultWordList
                    }else if(this.playEnType == 0){
                        this.resultList = that.resultWordList
                    }else if(this.playEnType == 1){
                        this.resultList = that.resultSentList
                    }
                    that.oldList = JSON.parse(JSON.stringify(res.data.data.dict_info.content)) 
                    }
                    


                // that.wordList = SimpleWords
                // that.newWord = SimpleWords[that.currentWordIndex]




                // const chunkSize = 18;
                // const result = [];
                // for (let i = 0; i < arr.length; i += chunkSize) {
                //     result.push(arr.slice(i, i + chunkSize));
                // }
                // that.resultList = result
                // that.oldList = JSON.parse(JSON.stringify(res.data.data.dict_info.content)) 


                

            }else{
                 if(res.data.code == 4001){
                    this.$router.push({name:'login',query:{qtype:this.$route.query.qtype}})
                }else{
                    that.$Message.error(res.data.msg);

                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
      queryScreenWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
           'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/screen/'+this.id,
          data:{}                                                                                             
          })                     
          .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.spinShow = false
                that.wordInfo = res.data.data
               let SimpleWords = []
                
                that.currentWordIndex = 0
                that.pageNum = 0
                that.pageIndex = 0
                
                // let arr = res.data.data.dict_info.content
                // if(this.showType == 3){
                //     that.pageIndex = 0
                //     let list = res.data.data.dict_info.content || []
                //     let list1 = []
                //     list.map((item)=>{
                //         if(item.phonetic){
                //             list1.push(item)
                //         }
                //     })
                   
                //     SimpleWords = list1
                //     that.SimpleWords = list1
                //     // arr = list1
                

                // }else{
                    SimpleWords = res.data.data.screen.content || []
                    that.SimpleWords = res.data.data.screen.content
                   
                // }

                that.queryVideoUrl()

                if(that.isOrder == 1){
                    const arr = res.data.data.screen.content
                        arr.map((item,index)=>{
                            item.index = index
                        })
                    that.newWord = SimpleWords[that.currentWordIndex]

                    const chunkSize = 18;
                    const result = [];
                    for (let i = 0; i < arr.length; i += chunkSize) {
                        result.push(arr.slice(i, i + chunkSize));
                    }
                    that.resultList = result
                    that.oldList = JSON.parse(JSON.stringify(res.data.data.screen.content)) 

                }else{
                    let allwordList = []
                    let allSenTList = []
                    SimpleWords.map(item=>{
                        if(item.word.indexOf(' ')>-1){
                            allSenTList.push(item)
                        }else{
                            allwordList.push(item)
                        }
                    })

                    allwordList.map((item,index)=>{
                        item.index = index
                    })

                    allSenTList.map((item,index)=>{
                        item.index = index
                    })

                    this.allwordList = allwordList
                    this.allSenTList = allSenTList

                    if(this.allwordList.length > 0&& this.allSenTList.length>0){
                        that.playEnType = 2
                        that.wordList = allwordList
                        that.SimpleWords = allwordList
                    }else if(this.allwordList.length>0 && this.allSenTList.length == 0){
                        this.playEnType = 0
                        that.wordList = allwordList
                        that.SimpleWords = allwordList
                    }else if(this.allSenTList.length>0 && this.allwordList.length == 0){
                        this.playEnType = 1
                        that.wordList = allSenTList
                        that.SimpleWords = allSenTList
                    }

                    that.newWord = this.wordList[that.currentWordIndex]

                    const chunkSize = 18;
                    const result = [];
                    for (let i = 0; i < allwordList.length; i += chunkSize) {
                        result.push(allwordList.slice(i, i + chunkSize));
                    }
                    that.resultWordList = result

                    const result1 = [];
                    for (let i = 0; i < allSenTList.length; i += chunkSize) {
                        result1.push(allSenTList.slice(i, i + chunkSize));
                    }
                    that.resultSentList = result1
                    // resultList
                    if( that.playEnType == 2){
                    this.resultList = that.resultWordList
                    }else if(this.playEnType == 0){
                        this.resultList = that.resultWordList
                    }else if(this.playEnType == 1){
                        this.resultList = that.resultSentList
                    }
                    that.oldList = JSON.parse(JSON.stringify(res.data.data.screen.content)) 
                    }
                    


                // that.wordList = SimpleWords
                // that.newWord = SimpleWords[that.currentWordIndex]




                // const chunkSize = 18;
                // const result = [];
                // for (let i = 0; i < arr.length; i += chunkSize) {
                //     result.push(arr.slice(i, i + chunkSize));
                // }
                // that.resultList = result
                // that.oldList = JSON.parse(JSON.stringify(res.data.data.dict_info.content)) 


                

            }else{
                 if(res.data.code == 4001){
                    this.$router.push({name:'login',query:{qtype:this.$route.query.qtype}})
                }else{
                    that.$Message.error(res.data.msg);

                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      }
    },

  };
  </script>
  
  <style scoped>
    .loginBG{
        width: 100%;
        height: 100%;
        /*background: url('https://r.bjwxjs.com/PC_kpy/enPageBackgroundPage.png') 0 0 / 100% 100% no-repeat;*/
        position: fixed;
        background: #ECF1F6;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .contentbox{
        padding:50px;
        box-sizing: border-box;
        height: 100%;
        margin:0 auto;
        width: 100%;
    }
    .contItem{
        width: 100%;
        height: 90%;
        display: flex;
        
    }
    .leftBox{
        width: 85%;
        height: 100%;
        /* background: url('https://r.bjwxjs.com/PC_kpy/pc_answerpage.png') 0 0/ 100% 100% no-repeat; */
        position: relative;
    }
    .topTime{
        width: 280px;
        height: 150px;
        background: #207DE5;
        border-radius: 75px;
        position: absolute;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .times{
        font-size: 90px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 100px;
        text-align: center;
        
    }
    .ivu-dropdown-menu{
        width: 180px;
        font-size: 22px;
    }
    .ivu-dropdown-item{
        height: 40px;
        font-size: 24px !important;
        text-align: center;
    }
    .timeInfo{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
    }
   .numberC{
        font-size: 26px;
        font-family: Helvetica;
        color: #606266;
        padding: 0 60px 0;
        box-sizing: border-box;
        margin-top: 30px;
        
   }
   .wordBox{
        width: 100%;
        height: 90%;;
        text-align: center;
        position: relative;
   }
   .wordBox >span{
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        display: inline-block;
        /* font-family: 'pinyin'; */

   }
   .wordBox1{
        width: 100%;
        height: 85%;
        overflow: auto;
        display: flex;
        flex-wrap:wrap;
        padding:0 50px 0 100px;

   }
  
   
@media (max-width: 1440px) {
      .wordBox1{
        width: 100%;
        height: 80%;
        overflow: auto;
        display: flex;
        flex-wrap:wrap;
        padding:0 50px 0 100px;

   }
} 

   .bottomBox{
        width: 180px;
        height: 50px;
        background: #FCFDFF;
        box-shadow: 0px 2px 5px 0px #95C9FF;
        border-radius: 10px;
        margin-left: 10px;
        display: flex;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #606266;
        text-shadow: 0px 2px 10px #95C9FF;
        line-height: 50px;
        padding: 0 10px;
        box-sizing: border-box;
   }
   .bottomBox > div{
         width: 180px;
        text-align: center;
   }
   .ivu-input-number-large{
        font-size: 20px;
        margin: 5px 15px;
        text-align: center;
        height: 38px !important;
        line-height: 36px;
        width: 60px !important;
   }
  /deep/ .ivu-input-number-input{
        text-align: center;
        height: 38px !important;
        line-height: 26px;
        width: 60px !important;
   }
   .timesNumber{
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #303133;
        text-align: center;
        margin-top: 40px;
        box-sizing: border-box;
   }
   .numberItem{
        display: flex;
        width: 100%; 
        height: 60px;
        margin: 10px auto 0;
        padding-left: 20px;
        box-sizing: border-box;
        justify-content: center;
   }
   .timeItem{
        width: 36px;
        height: 60px;
        background: rgba(255,255,255,0.8);
        box-shadow: 0px 2px 5px 0px #95C9FF;
        border-radius: 6px;
        border: 2px solid #207DE5;
        font-size: 36px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #303133;
        line-height: 60px;
        margin-right: 10px;
        text-align: center;
   }
   .timeItem1{
        font-size: 36px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #303133;
        line-height: 40px;
         margin-right: 10px;
   }
   .startBtn{
        width: 180px;
        height: 60px;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_button_BG@2x.png') 0 0 / 100% 100% no-repeat;
        font-size: 26px;
        font-family: HiraginoSansGB-W6, HiraginoSansGB;
        font-weight: normal;
        color: #207DE5;
        text-align: center;
        line-height: 60px;
        margin: 10px auto 0;
        cursor:pointer
    }
    .goback{
        width: 180px;
        height: 50px;
        font-size: 20px;
        line-height: 40px;
        margin: 20px auto;
    }
    .rightBox{
        width: 15%;
    }
    .audiosBox{
        position: fixed;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .worditem{
       margin-right: 16px;
    }
    .worditem >div{
         display: flex;
        flex-wrap: wrap;
    }
     ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .pinBox{
        font-size: 26px;
        /* font-family: "pinyin";; */
        color: #000000;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background: url('https://r.bjwxjs.com/PC_kpy/IMG_9180.png') center center / 100% 60% no-repeat;
    }
    .pinBox:nth-child(2){
        margin-left: -1px;
    }
    .pinBox:nth-child(3){
        margin-left: -1px;
    }
    .pinBox:nth-child(4){
        margin-left: -1px;
    }
    .ziBox{
        font-size: 45px;
        font-family: ArialMT;
        color: #000000;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_fangge_icon.png') 0 0 / 100% 100% no-repeat;
    }
    .ziBox:nth-child(2){
        margin-left: -1px;
    }
    .ziBox:nth-child(3){
        margin-left: -1px;
    }
    .ziBox:nth-child(4){
        margin-left: -1px;
    }
    .ivu-dropdown{
        margin: 0 auto;
    }
    .leftBoxs{
        text-align: center;
    }
    .wordBox{

    }
     .wordBox2{
        width: 100%;
        height: 100%;;
        text-align: center;
        padding: 0 30px;
        box-sizing: border-box;

   }
   
    .WordPage{
        position: relative;
        width: 33.33%;
        height: 16.7%;
        text-align: center;
        border-bottom: 1px solid #207DE5;
        border-left: 1px solid #207DE5;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
        padding: 0 30px;
        float: left;
        font-weight: 600;

    }
    .WordPage:nth-child(1){
         border-top: 1px solid #207DE5;
    }
    .WordPage:nth-child(2){
         border-top: 1px solid #207DE5;
    }
    .WordPage:nth-child(3){
        border-top: 1px solid #207DE5;
    }
    .WordPage:nth-child(3n){
        border-right: 1px solid #207DE5;
    }
    .WordPage:last-child{
        border-right: 1px solid #207DE5;
    }
    .indexPg{
        width: 45px;
        height: 45px;
        border-radius: 150px;
        box-sizing: border-box;
        border: 1px solid rgba(0,0,0,0.8);
        line-height: 45px;
        text-align: center;
        font-size: 33px;
        position: absolute;
        left: 10px;
        top: 10px;
    }
    .wordNe{
        font-size: 30px;
    }
    .zhSize{
         font-size: 36px;
         /* width: 100%;
         height: 100%; */
    }
    .payVipBox{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background:rgba(0, 0, 0, 0.6);
        z-index: 10;
    }
    .PayBoxs{
        width: 500px;
        height: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: #FFFFFF;
        border-radius: 20px;
    }
    .payTitle{
        font-size: 32px;
        font-weight: 600;
        text-align: center;
        margin-top: 30px;
        color: #333333;
    }
    .infosBox{
        font-size: 24px;
        color: #333333;
        text-indent:2em;
        line-height: 40px;
        padding: 0 30px;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .payMage{
        width: 200px;
        height: 200px;
        margin:20px auto;
    }
    .payMage img{
        width: 100%;
        height: 100%;
    }
    .buttonTitle{
        text-align: center;
        color: #333333;
        font-size: 26px;
    }
     .poson{
        position: absolute;
         bottom: 80px;
        right: 70px;
    }
    .buttomItems{
        position: fixed;
        bottom: 0;
        left: 50%;
        width: 600px;
        height: 60px;
        background-color: #fff;
        border-radius: 12px;
        transform: translate(-50%,-50%);
        box-shadow: 0px 4px 20px 0px #95C9FF;
        text-align: center;
        font-size: 20px;
        line-height: 60px;
        display: flex;
        /* flex-direction:row;
        justify-content:space-between; */
        padding: 0 100px;
        box-sizing: border-box;
    }
   
    .buttomItems /deep/ .ivu-input-number-input{
        text-align: center;
        font-size: 20px;
   }
   .sizeBnt{
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translate(0,-50%);
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding-left: 30px;
    cursor: pointer;
    background: url('https://r.bjwxjs.com/PC_kpy/sortPageNums.png') 0 center / 30px 30px no-repeat;
   }
   .ivu-checkbox-wrapper{
    font-size: 16px;
   }
   .showNumber{
    position: fixed;
    top: 50px;
    left: 50px;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    font-size: 70px;
    text-align: center;
    line-height: 80px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 500;
   }
   .nextMin{
    position: fixed;
    width: 900px;
    height: 400px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 150px;
    text-align: center;
    background-color: #fff;
    border-radius: 30px;
    z-index: 9999;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px 0px rgba(0,3,71,0.09);
    
   }
   .timeMin{
    line-height: 100px;
   }
   .ready{
    font-size: 80px;
    height: 200px;
    line-height: 200px;
    
   }
   .boxLeftBtn{
        position: fixed;
        right: 0;
        top: 240px;
        width: 124px;
        height: 68px;
        cursor: pointer;
        border-radius: 50px 0 0 50px;
        background-color: #fff;
        line-height: 68px;
        text-align: center;
        font-size: 26px;
    }
    .boxLeftBtn img{
        width: 28px;
        height: 28px;
        vertical-align: middle;
        margin-top: -2px;
    }
    .el-icon-arrow-left{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0,-50%);

    }
    .drawerBox{
        width: 420px;
        height: 900px;
        position: fixed;
        right: 0;
        top: 10px;
        background-color: #fff;
        border-radius: 16px 0 0 16px;
        /* padding: 40px; */
        box-sizing: border-box;
    }
    .drawerBoxTitle{
        position: relative;
        height: 80px;
        padding: 0 20px;
        box-sizing: border-box;
        background: rgb(240, 247, 255);
        border-radius: 16px 0 0 0;
        font-size: 26px;
        line-height: 80px;
    }
    .drawerBoxTitle img{
        width: 30px;
        height: 30px;
        vertical-align: middle;
        margin-right: 16px;
        margin-top: -4px;

    }
    .closeBtn{
        position: absolute;
        width: 16px;
        height: 16px;
        background: url('https://r.bjwxjs.com/EnImage/pcEnCloseBTN.png') 0 0 /100% 100% no-repeat;
        top: 50%;
        right: 30px;
        transform: translate(0,-50%);
    }
    .rightBtnFX{
        width: 180px;
        margin: 0 auto;
    }
    .drawerTitle{
        font-size: 28px;
        color: rgb(48, 49, 51);
        padding: 0 40px;
        box-sizing: border-box;
        margin-top: 30px;
    }
    .optBoxAudio{
        margin: 0 40px;
        background: rgba(240, 247, 255, 0.6);
        height: 64px;
        border-radius: 10px;
        display: flex;
        margin-top: 16px;
        cursor: pointer;
    }
    .optBoxAudio div{
        width: 33.33%;
        text-align: center;
        line-height: 64px;
        font-size: 24px;
    }
    .flexBoxLarge{
        width: 100%;
        display: flex;
        padding: 0 40px;
        box-sizing: border-box;
        margin-top: 18px;
    }
    .clwidth{
        width: 50% !important;
    }
    .clwidth:nth-child(1){
        border-right: 2px solid rgba(135, 188, 246, 0.28);
    }
    .sizeInput{
        height: 30px;
        line-height: 30px;
    }
    .sizeInput /deep/ .ivu-input-number-input{
        height: 26px !important;
        line-height: 26px !important;
    }
    .colesSet{
       
        width: 120px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        font-size: 20px;
        color: #207DE5;
        cursor: pointer;
        border: 1px solid #207DE5;
        border-radius: 6px;
        margin: 30px auto;
    }
    /deep/ .ivu-slider-button-wrap{
        top: -11px !important;
    }
    .ivu-slider{
        padding-top: 10px;
    }
  </style>
  